import React, { useState , useEffect} from 'react';
import { useCookies } from 'react-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import db from "../../functions/firestore.js";
import { options } from "../../functions/functions.js";
import Logo from "../../images/transparenttextlogo.svg";
import Loader from "../site/loader.js";


export default function MovieArcSite() {
    const [cookies, setCookie] = useCookies(['user' , 'mood', 'genre']);
    const [ pickMood , setMoodAndGenre] = useState(true);
    const [ feelings , setfeelings] = useState([]);

    const [ preferenceFeels , setPF] = useState([]);
    const [ preferenceGenre , setPG] = useState([]);

    //FETCHING ALL FEELINGS
    const fetchfeelings = async() => {
        await db.collection("feelings").get().then(querySnapshot => {
            const docs = querySnapshot.docs.map(doc => doc.data());
            setfeelings(docs);
        });
    }

    useEffect(() => {
        fetchfeelings();
    }, [])

    const findYourPreferences = () => {  setMoodAndGenre(false); };

    const setPreferenceFeelings = (data) => {  setPF([...preferenceFeels , data]) };
    const removePreferenceFeelings = (data) => { 
        const i = preferenceFeels.findIndex( str => str === data );
        const ndata = preferenceFeels.slice(0, i).concat(preferenceFeels.slice(i + 1, preferenceFeels.length))

        setPF(ndata)
     };

    const setPreferenceGenre = (data) => {  setPG([...preferenceGenre , data]) };
    const removePreferenceGenre = (data) => { 
        const i = preferenceGenre.findIndex( str => str === data );
        const ndata = preferenceGenre.slice(0, i).concat(preferenceGenre.slice(i + 1, preferenceGenre.length))

        setPG(ndata)
     };    

     
     
     const savePreferences = () => { 
        if(preferenceFeels){
            setCookie('mood', preferenceFeels, {path: '/', expires: new Date(new Date().getTime() + 86400000), maxAge: 86400000  });
        }else{
            setCookie('mood', [], {path: '/', expires: new Date(new Date().getTime() + 86400000), maxAge: 86400000  });
        }        
        if(preferenceGenre){
            setCookie('genre', preferenceGenre, {path: '/', expires: new Date(new Date().getTime() + 86400000), maxAge: 86400000  });
        }else{
            setCookie('genre', [], {path: '/', expires: new Date(new Date().getTime() + 86400000), maxAge: 86400000  });
        }   
        window.location = "/";
     };


    if(pickMood){
        return (
        <section  className="promo">
            <div className="promodiv">
                <img src={Logo} className="img-fluid" alt = "bg"/>
                <div className="promo-text">
                    <p>
                    MovieArc is a free site to help you easier find movies to watch based on your mood and genre. <br/>
                    Since is free, we are looking to improve our filters based on your preferences. <br/>
                    If you are interested, please review some of the movies, so that you and the others get best possible results. <br/>
                    Click Continue and select your current preferences for watching a movie. <br/>
                    </p>
                </div>
                <div className="promo-btn text-right">
                    <a onClick={(e) => { e.preventDefault(); findYourPreferences(); }}>Continue <FontAwesomeIcon icon={["fas", "angle-double-right"]}  /></a>
                </div>
            </div>
        <Loader />
        </section>
        )
    }else{
        return (
        <section  className="promo">
            <div className="promodiv">
                <img src={Logo} className="img-fluid" alt = "bg"/>
                <div className="promo-text">
                    <h3>Pick mood:</h3>
                    {
                    feelings && feelings.map(data=>{
                        let disabled = '';
                        if(preferenceFeels){
                            disabled = preferenceFeels.filter( str => str === data.feeling_name )
                        }
                        if(disabled && disabled.length){
                            return(<a onClick={() => { removePreferenceFeelings(data.feeling_name)}} className="active"> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]}  />  </h5> </a>)
                        }else{
                            return(<a onClick={(e) => { e.preventDefault(); setPreferenceFeelings(data.feeling_name) }}> <h5>{data.feeling_name} <FontAwesomeIcon icon={["fas", "check-circle"]}  /></h5></a>)
                        }
                    })
                    }
                    <h3>Pick genre:</h3>
                    {
                    options && options.map(data=>{
                        let disabled = '';
                        if(preferenceGenre){
                            disabled = preferenceGenre.filter( str => str === data.value )
                        }
                        if(disabled && disabled.length){
                            return(<a onClick={(e) => {  e.preventDefault();  removePreferenceGenre(data.value)}} className="active"> <h5>{data.value} <FontAwesomeIcon icon={["fas", "check-circle"]}  /></h5></a>)
                        }else{
                            return(<a onClick={(e) => { e.preventDefault(); setPreferenceGenre(data.value) }}> <h5>{data.value} <FontAwesomeIcon icon={["fas", "check-circle"]}  /></h5></a>)
                        }
                    })
                    }
                </div>
                <div className="promo-btn text-right">
                    <a onClick={(e) => { e.preventDefault(); savePreferences(); }}>Continue <FontAwesomeIcon icon={["fas", "angle-double-right"]}  /></a>
                </div>
            </div>
        </section>
        )
    } 
}
